import { getCardsData } from '@aviv-classified-card/card/full';
import { isEmpty } from 'lodash';
import { MAX_RESULTS } from '../../helpers/constants';
import { isServer } from '../../helpers/isServer';
import { createEnrichedData } from './createEnrichedData';
import { getEffectIdsBySearchServiceModel } from './getEffectIdsBySearchServiceModel';
import { getEnlargedIdsBySearchServiceModel } from './getEnlargedIdsBySearchServiceModel';
import { getIdsBySearchServiceModel } from './getIdsBySearchServiceModel';
import { getVisibilityEffects } from './getVisibilityEffects';
import { PaginationExceededError } from './paginationExceededError';
export const fetchSearchData = async ({ bffUri, stage, page, order, searchServiceModel, pageSize, brand, language, searchEndpoints, numberOfSuggestions = 0, }) => {
    if (page * pageSize > MAX_RESULTS)
        throw new PaginationExceededError('Pagination exceeded');
    const isServerSide = isServer();
    // Step 1: fetching search scope related classified ids and suggestions
    const getClassifiedIdsPromise = await getIdsBySearchServiceModel({
        bffUri,
        page,
        order,
        searchServiceModel,
        pageSize,
        endpoint: searchEndpoints.search,
    });
    const getEffectsPromise = getEffectIdsBySearchServiceModel({
        bffUri,
        suggestions: numberOfSuggestions === 0 ? 0 : numberOfSuggestions + 2,
        searchServiceModel,
        endpoint: searchEndpoints.effect,
    });
    const [{ totalCount, classifieds: classifiedIds }, { classifieds: suggestedClassifiedIds, topPositionId }] = await Promise.all([getClassifiedIdsPromise, getEffectsPromise]);
    // Step 2: fetching enlarged classified ids
    const enlargementSize = pageSize - classifiedIds.length;
    const enlargementProps = {
        bffUri,
        pageSize: enlargementSize,
        searchServiceModel,
        endpoint: searchEndpoints.enlargement,
    };
    const { classifieds: enlargedClassifiedIds } = enlargementSize > 0 ? await getEnlargedIdsBySearchServiceModel(enlargementProps) : { classifieds: [] };
    // Step 3: fetching cards data & visibility effects for all ids (classifieds + enlarged + suggestions)
    const suggestedClassifiedsWithoutDuplicates = suggestedClassifiedIds.filter((id) => !classifiedIds.includes(id) && !enlargedClassifiedIds.includes(id));
    const allClassifiedIds = [
        ...classifiedIds,
        ...enlargedClassifiedIds,
        ...suggestedClassifiedsWithoutDuplicates,
        ...(topPositionId ? [topPositionId] : []),
    ];
    const getCardsDataPromise = !isEmpty(allClassifiedIds)
        ? getCardsData(allClassifiedIds, brand, stage, language, isServerSide)
        : Promise.resolve({ data: {}, errored: false, message: undefined });
    const getVisibilityEffectsPromise = getVisibilityEffects({ bffUri, classifieds: allClassifiedIds });
    const [{ data: classifiedsData, errored, message }, visibilityEffects] = await Promise.all([
        getCardsDataPromise,
        getVisibilityEffectsPromise,
    ]);
    const enrichedClassifiedsData = createEnrichedData({
        visibilityEffects,
        suggestedClassifiedsIds: suggestedClassifiedsWithoutDuplicates,
    });
    // If an error occurred while fetching cards data we need to throw here an
    // error manually to display the error component correctly for the user
    if (errored)
        throw new Error(`Get cards data errored: ${message}`);
    return {
        totalCount,
        topPositionId,
        classifieds: classifiedIds,
        enlargedClassifieds: enlargedClassifiedIds,
        suggestedClassifieds: suggestedClassifiedsWithoutDuplicates,
        classifiedsData,
        enrichedClassifiedsData,
    };
};
